import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getThemeColors, THEME_OPTIONS } from '../theme'

const PLANS = [
  {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: '/ mes',
    tagline: 'Empieza gratis y valida tu pipeline de búsqueda.',
    cta: 'Plan actual',
    accent: 'default',
    features: [
      'Hasta 5 keywords activas',
      'Hasta 5 vacantes por día',
      'Scoring con Nyx.ia',
      'Dashboard de vacantes',
      'Acceso web',
    ],
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 'Próximamente',
    period: '',
    tagline: 'Todo lo de Free, más profundidad, volumen y alertas.',
    cta: 'Quiero Premium',
    accent: 'primary',
    features: [
      'Todo lo incluido en Free',
      'Scraping completo',
      'Scoring Nyx.ia más detallado',
      'Más vacantes y más keywords',
      'Alertas y seguimiento más útil',
      'Dashboard completo',
    ],
  },
  {
    id: 'pro',
    name: 'Premium Pro',
    price: 'Próximamente',
    period: '',
    tagline: 'Para usuarios intensivos que quieren automatización avanzada.',
    cta: 'Quiero Premium Pro',
    accent: 'secondary',
    features: [
      'Todo lo incluido en Premium',
      'Auto-apply',
      'Prioridad en resultados',
      'Ajustes finos del perfil',
      'Automatizaciones más avanzadas',
      'Mayor control operativo',
    ],
  },
]

export default function Planes({ theme = THEME_OPTIONS.LIGHT, session = null, isModal = false, onClose = null }) {
  const C = getThemeColors(theme)
  const navigate = useNavigate()

  const planCard = (plan) => {
    const isPrimary = plan.accent === 'primary'
    const isSecondary = plan.accent === 'secondary'

    return {
      background: isPrimary ? C.blueLight : C.white,
      border: `1px solid ${isPrimary ? C.blue : isSecondary ? C.purpleBorder : C.border}`,
      borderRadius: '18px',
      padding: '24px',
      boxShadow: C.shadow,
    }
  }

  const content = (
      <div style={{ maxWidth: '1120px', margin: '0 auto', padding: isModal ? '28px' : '36px 32px 48px', boxSizing: 'border-box' }}>
        <div style={{ marginBottom: '30px', maxWidth: '760px' }}>
          <div style={{ fontSize: '11px', color: C.blue, textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: '600', marginBottom: '8px' }}>
            Planes
          </div>
          <div style={{ fontSize: '34px', fontWeight: '500', letterSpacing: '-1px', lineHeight: '1.1', marginBottom: '10px' }}>
            Elige el plan que mejor se ajuste a tu búsqueda
          </div>
          <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.7' }}>
            Free mantiene la lógica actual. Premium suma profundidad, mejores alertas y más capacidad. Premium Pro empuja la automatización al siguiente nivel.
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', alignItems: 'start' }}>
          {PLANS.map((plan) => (
            <div key={plan.id} style={planCard(plan)}>
              <div style={{ fontSize: '13px', color: plan.accent === 'primary' ? C.blue : plan.accent === 'secondary' ? C.purple : C.muted, fontWeight: '600', marginBottom: '8px' }}>
                {plan.name}
              </div>
              <div style={{ fontSize: '40px', fontWeight: '500', letterSpacing: '-1.4px', lineHeight: '1', marginBottom: '8px' }}>
                {plan.price}
                <span style={{ fontSize: '16px', color: C.muted, fontWeight: '400' }}>{plan.period}</span>
              </div>
              <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.7', minHeight: '44px', marginBottom: '18px' }}>
                {plan.tagline}
              </div>

              <button
                onClick={() => {
                  if (plan.id === 'free') {
                    navigate('/login')
                    return
                  }
                  if (onClose) onClose()
                }}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  background: plan.id === 'free' ? C.white : C.blue,
                  color: plan.id === 'free' ? C.text : '#fff',
                  border: `1px solid ${plan.id === 'free' ? C.border : C.blue}`,
                  borderRadius: '10px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginBottom: '18px',
                }}
              >
                {plan.cta}
              </button>

              <div style={{ fontSize: '14px', fontWeight: '500', marginBottom: '10px' }}>
                {plan.id === 'free' ? 'Incluye:' : plan.id === 'premium' ? 'Todo lo de Free y:' : 'Todo lo incluido en Premium, más:'}
              </div>
              <div style={{ display: 'grid', gap: '8px' }}>
                {plan.features.map((feature) => (
                  <div key={feature} style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', fontSize: '13px', color: C.muted, lineHeight: '1.6' }}>
                    <span style={{ color: C.blue, fontWeight: '700' }}>✓</span>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
  )

  if (isModal) {
    return (
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: '1180px', maxHeight: '90vh', overflowY: 'auto', background: C.bg, border: `1px solid ${C.border}`, borderRadius: '20px', boxShadow: C.shadow, position: 'relative' }}>
          <button onClick={onClose} style={{ position: 'absolute', top: '16px', right: '16px', width: '36px', height: '36px', borderRadius: '999px', border: `0.5px solid ${C.border}`, background: C.white, color: C.text, cursor: 'pointer', fontSize: '18px' }}>×</button>
          {content}
        </div>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <nav style={{ background: C.white, borderBottom: `0.5px solid ${C.border}`, padding: '12px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ fontSize: '15px', fontWeight: '500', cursor: 'pointer' }} onClick={() => navigate(session ? '/dashboard' : '/')}>
          Job<span style={{ color: C.blue }}>Pipeline</span>
        </div>
        <button onClick={() => navigate(session ? '/dashboard' : '/')} style={{ fontSize: '12px', color: C.blue, background: C.blueLight, border: `0.5px solid ${C.border}`, borderRadius: '8px', padding: '8px 14px', cursor: 'pointer' }}>
          {session ? 'Volver al dashboard' : 'Volver al inicio'}
        </button>
      </nav>
      {content}
    </div>
  )
}
